<template>
  <div class="edit-generic-submission">
    <label>
      <h3>Title</h3>
      <input
        type="text"
        v-model="value.title" placeholder="Title" />
    </label>
    <label>
      <h3>Description</h3>
      <textarea
        v-model="value.description"
        placeholder="Description"
        rows="7"
        cols="50"></textarea>
    </label>
  </div>
</template>

<script>
export default {
  name: 'EditGenericSubmission',
  props: {
    value: {
      type: Object,
      default () {
        return {
          title: '',
          description: ''
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
